import { render } from "./service_page.vue?vue&type=template&id=056a730e&scoped=true"
import script from "./service_page.vue?vue&type=script&lang=js"
export * from "./service_page.vue?vue&type=script&lang=js"

import "./service_page.vue?vue&type=style&index=0&id=056a730e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056a730e"]])

export default __exports__